import request from '@/modules/base/util/request'
import config from '@/config'

const baseUrl = `${config.resourceHost}`

export const TenantCollaboratorsService = {
  getCollaborators: () => {
    return new Promise((resolve, reject) => {
      request(`${baseUrl}tenant/collaborators`, {
        auth: true,
        isConcurrent: true,
      })
        .then(response => {
          const { body } = response
          resolve(body)
        })
        .catch(error => reject(error))
    })
  },
  getCollaboratorUsers: (collaboratorId, hasConfirmedEmail = false) => {
    return new Promise((resolve, reject) => {
      const query = new URLSearchParams({ hasConfirmedEmail })
      request(`${baseUrl}tenant/collaborators/${collaboratorId}/users?${query.toString()}`, {
        auth: true,
        isConcurrent: true,
      })
        .then(response => {
          const { body } = response
          resolve(body)
        })
        .catch(error => reject(error))
    })
  },
}

export default TenantCollaboratorsService
